import React, { useEffect } from 'react'
import { useDispatch, useSelector } from "react-redux";
import ChartDataLabels from 'chartjs-plugin-datalabels';
import {
    Chart as ChartJs,
    ArcElement,
    Tooltip,
    Legend
} from 'chart.js/auto'

import { Pie } from 'react-chartjs-2';

ChartJs.register(
    ArcElement,
    Tooltip,
    Legend
)
ChartJs.register(ChartDataLabels)
export default function PiChart({ dashboardId }) {
    const dashboardData = useSelector(state => state.dashboardReducer.userDashboard.userdashboardData);
    if (dashboardData === null) {
        return <div />;
    }
    let datas = dashboardData[dashboardId];
    let dataRows = datas.dataRows;
    if(dataRows.length===0){
        return <div></div>;
      }
    //get all chart label
    const chartLabels = dataRows.map(row => {
        const chartLabel = row.fields.find(field => field.fieldName === 'CHARTLABEL');
        return chartLabel ? chartLabel.fieldValue : null;
    }).filter(label => label !== null);
    //get all chart value
    const chartValues = dataRows.map(row => {
        const chartValue = row.fields.find(field => field.fieldName === 'CHARTVALUE');
        return chartValue ? chartValue.fieldValue : null;
    }).filter(value => value !== null);
    // Generate random colors for each label
    const chartColor = chartLabels.map(() => {
        return `rgb(${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)})`;
    });
    //get chart colors from the query
    const chartColors= dataRows.map(row => {
        const chartLabel = row.fields.find(field => field.fieldName === 'CHARTCOLOR');
        return chartLabel ? chartLabel.fieldValue : null;
    }).filter(label => label !== null);

    //
    const data = {
        labels: chartLabels,
        datasets: [
            {
                data: chartValues, // Percentage
                backgroundColor: chartColor,
                hoverOffset: 4
            },

        ]
    };
    const options = {
        plugins: {
            // Change options for ALL labels of THIS CHART
            
          
            datalabels: {
              color: '#000',
            
              
            },
            legend: {
                position: 'right',
               // rtl : true,
                labels: {
                  usePointStyle: true,
                  pointStyle: 'circle',
                }}
          },
          
    }
    return (
        
        <div class="col-xl-4 col-lg-6 order-lg-1" key={dashboardId}>
            <div class="card">
                <div class="card-body">
                <div className="alert alert-primary" role="alert">
                        <h4> <i className='mdi mdi-chart-pie'></i> {datas.dashboardTitle} </h4>
                    </div>

                    <div class="mt-3 chartjs-chart">
                        <Pie
                            data={data}
                            options={options}
                        >
                        </Pie>

                    </div>
                    {/* <div class="chart-widget-list">
                    {chartLabels.map((label, index) => {
                            const value = chartValues[index];
                            return (
                                <p> {label}
                                    <span class="float-end">{value}</span>
                                </p>
                            );
                        })}
                    </div> */}
                </div>
            </div>
        </div>

    )
}
